/**
 * Activate alarm, it will trigger (unless canceled) after the set time
 *
 * @param {string} type - Slug that will be used to track timeout id
 * @param {string} msg - Message to send to notification service
 * @param {string} callback - The callback method to be invoked which triggers the notification
 * @returns {void}
 */
export function activateAlarm(type, callback, msg = '', timeout = 15000) {
  if (process.env.NODE_ENV !== 'production' || window.location.href.indexOf('/edit/') > -1) {
    return;
  }

  if (!msg) {
    msg = `Alarm triggered for ${type}. URL: ${window.location.href}`;
  }

  const container = `${type}Timeout`;

  if (!window[container]) {
    window[container] = callback(msg, timeout);
  }
}

/**
 * Deactivate alarm, canceles previously set alarm
 *
 * @param {string} type - Slug that was used to activate the alarm
 * @returns {void}
 */
export function deactivateAlarm(type) {
  const container = `${type}Timeout`;
  clearTimeout(window[container]);
}
